<template>
  <div>
    <div class="app-nav">
      <div class="row expanded">
        <div class="columns">
          <nav></nav>
        </div>
      </div>
    </div>
    <div class="app flex-row align-items-center">
      <div class="container">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4"></h1>
          <h4 class="pt-3">Logging you in!</h4>
          <p class="text-muted">Any minute now...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Callback",
  methods: {}
};
</script>